export default {
  formId: 'createCargoForm', //'checkoutForm',
  formField: {
    e_name: {
      name: 'e_name',
      label: 'Nombre cargo*',
      requiredErrorMsg: 'El nombre cargo es requerido.',
    },
    e_description: {
      name: 'e_description',
      label: 'Descripcion*',
      requiredErrorMsg: 'La descripcion es requerida.',
    },
    e_area: {
      name: 'e_area',
      label: 'Area',
      requiredErrorMsg: 'El area es requerida.',
    },
    e_visita_domiciliaria: {
      name: 'e_visita_domiciliaria',
      label: 'visita domiciliaria',
      requiredErrorMsg: 'La visita domiciliaria es requerida.',
    },
    e_prueba_psicotecnica: {
      name: 'e_prueba_psicotecnica',
      label: 'prueba psicotecnica',
      requiredErrorMsg: 'La prueba psicotecnica es requerida.',
    },
    e_examen_alimentos: {
      name: 'e_examen_alimentos',
      label: 'examen alimentos',
      requiredErrorMsg: 'El examen alimentos es requerido.',
    },
    e_examen_alturas: {
      name: 'e_examen_alturas',
      label: 'examen de alturas',
      requiredErrorMsg: 'El examen de alturas es requerido.',
    },
    e_certificado_laboral: {
      name: 'e_certificado_laboral',
      label: 'certificado laboral',
      requiredErrorMsg: 'El certificado laboral es requerido.',
    },
    e_certificado_estudios: {
      name: 'e_certificado_estudios',
      label: 'certificado estudios',
      requiredErrorMsg: 'El certificado de estudios es requerido.',
    },
    e_adres: {
      name: 'e_adres',
      label: 'adres',
      requiredErrorMsg: 'El adres es requerido.',
    },
    e_antecedentes_judicial: {
      name: 'e_antecedentes_judicial',
      label: 'antecedentes judicial',
      requiredErrorMsg: 'Los antecedentes judiciales son requeridos.',
    },
    e_entrevista: {
      name: 'e_entrevista',
      label: 'entrevista',
      requiredErrorMsg: 'La entrevista es requerida.',
    },
    e_sociodemografica: {
      name: 'e_sociodemografica',
      label: 'sociodemografica',
      requiredErrorMsg: 'La sociodemografica es requerida.',
    },
    e_dme: {
      name: 'e_dme',
      label: 'dme',
      requiredErrorMsg: 'La dme es requerida.',
    },
    e_sst: {
      name: 'e_sst',
      label: 'sst',
      requiredErrorMsg: 'La sst es requerida.',
    },
  },
};
